<template>
    <div class="accordion container shadow p-4 mb-4 mt-4" id="accordionExample">
        <div class="accordion-item mb-2">
            <h2 class="accordion-header" id="headingSistemi">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#sistemi" aria-expanded="false" aria-controls="sistemi">
                    Lista Sistemi
                </button>
            </h2>

            <div id="sistemi" class="accordion-collapse collapse shadow" aria-labelledby="headingSistemi"
                data-bs-parent="#accordionExample">
                <div class="accordion-body">

                    <!-- Add New Button -->
                    <div class="d-flex justify-content-end mb-3">
                        <button class="btn btn-success" @click="addSystem()">+ Nuovo</button>
                    </div>

                    <!-- Table -->
                    <div class="table-responsive">
                                                <table class="table table-sm table-hover table-striped align-middle">
                            <thead class="table-light">
                                <tr>
                                    <th><input type="text" v-model="searchSys" placeholder="Cerca.."></th>
                                    <th></th>
                                </tr>
                            </thead>
                        </table>
                        <table class="table table-sm table-hover table-striped align-middle">
                            <thead class="table-light">
                                <tr>
                                    <th>ID</th>
                                    <th>Nome Sistema</th>
                                    <th class="text-end">Azioni</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="system in systems" :key="system.id">
                                    <template v-if="searchSys=='' || system.system_name.toLowerCase().includes(searchSys.toLowerCase())">
                                    <td>{{ system.id }}</td>
                                    <td>{{ system.system_name }}</td>
                                    <td class="text-end">
                                        <button class="btn btn-sm btn-outline-success" @click="selectSystem(system)">
                                            Modifica
                                        </button>
                                    </td>
                                    </template>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        </div>

        <div class="accordion-item mb-2">
            <h2 class="accordion-header" id="headingGruppi">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#gruppi" aria-expanded="false" aria-controls="gruppi">
                    Lista Gruppi
                </button>
            </h2>

            <div id="gruppi" class="accordion-collapse collapse shadow" aria-labelledby="headingGruppi"
                data-bs-parent="#accordionExample">
                <div class="accordion-body">

                    <!-- Add New Button -->
                    <div class="d-flex justify-content-end mb-3">
                        <button class="btn btn-success" @click="addGroup()">+ Nuovo</button>
                    </div>

                    <!-- Table -->
                    <div class="table-responsive">
                        <table class="table table-sm table-hover table-striped align-middle">
                            <thead class="table-light">
                                <tr>
                                    <th>ID</th>
                                    <th>Nome Gruppo</th>
                                    <th class="text-end">Azioni</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="group in groups" :key="group.id">
                                    <td>{{ group.id }}</td>
                                    <td>{{ group.group_name }}</td>
                                    <td class="text-end">
                                        <button class="btn btn-sm btn-outline-success" @click="selectGroup(group)">
                                            Modifica
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        </div>

        <div class="accordion-item mb-2">
            <h2 class="accordion-header" id="headingsuperfici">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#superfici" aria-expanded="false" aria-controls="superfici">
                    Lista Superfici
                </button>
            </h2>

            <div id="superfici" class="accordion-collapse collapse shadow" aria-labelledby="headingsuperfici"
                data-bs-parent="#accordionExample">
                <div class="accordion-body">

                    <!-- Add New Button -->
                    <div class="d-flex justify-content-end mb-3">
                        <button class="btn btn-success" @click="newBase = { id: -1, base_name: '' }; modBase.show()">+
                            Nuovo</button>
                    </div>

                    <!-- Table -->
                    <div class="table-responsive">
                        <table class="table table-sm table-hover table-striped align-middle">
                            <thead class="table-light">
                                <tr>
                                    <th><input type="text" v-model="searchSup" placeholder="Cerca.."></th>
                                    <th></th>
                                </tr>
                            </thead>
                        </table>
                        <table class="table table-sm table-hover table-striped align-middle">
                            <thead class="table-light">
                                <tr>
                                    <th>Nome Superficie</th>
                                    <th class="text-end">Azioni</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="base in bases" :key="base.id">
                                    <template v-if="searchSup=='' || base.base_name.toLowerCase().includes(searchSup.toLowerCase())">
                                    <td>{{ base.base_name }}</td>
                                    <td class="text-end">
                                        <button class="btn btn-sm btn-outline-success"
                                            @click="newBase = base; modBase.show()">
                                            Modifica
                                        </button>
                                    </td>
                                    </template>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        </div>

        <div class="accordion-item mb-2">
            <h2 class="accordion-header" id="headingAgenti">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#agenti" aria-expanded="false" aria-controls="agenti">
                    Lista Utenti
                </button>
            </h2>

            <div id="agenti" class="accordion-collapse collapse shadow" aria-labelledby="headingAgenti"
                data-bs-parent="#accordionExample">
                <div class="accordion-body">
                    <div class="d-flex justify-content-end mb-3">
                        <button class="btn btn-success" @click="addUser(); modUser.show()">+ Nuovo</button>
                    </div>

                    <div class="table-responsive">
                        <table class="table table-sm table-hover table-striped align-middle">
                            <thead class="table-light">
                                <tr>
                                    <th><input type="text" v-model="searchUser" placeholder="Cerca.."></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                        </table>
                        <table class="table table-sm table-hover table-striped align-middle">
                            <thead class="table-light">
                                <tr>
                                    <th>ID</th>
                                    <th>Username</th>
                                    <th>Email</th>
                                    <th>Ruolo</th>
                                    <th class="text-end">Azioni</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="user in users" :key="user.id">
                                    <template v-if="searchUser=='' || user.username.toLowerCase().includes(searchUser.toLowerCase())">
                                    <td>{{ user.id }}</td>
                                    <td>{{ user.username }}</td>
                                    <td>{{ user.email }}</td>
                                    <td>
                                        <span class="badge bg-primary" v-if="user.role == 1">Agente</span>
                                        <span class="badge bg-danger" v-else-if="user.role == 2">Admin</span>
                                    </td>
                                    <td class="text-end">
                                        <button class="btn btn-sm btn-outline-success"
                                            @click="selectUser(user); modUser.show()">
                                            Modifica
                                        </button>
                                    </td>
                                    </template>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        </div>

        <div class="accordion-item mb-2">
            <h2 class="accordion-header" id="headingResa">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#Resa" aria-expanded="false" aria-controls="Resa">
                    Regole Calcolo Resa
                </button>
            </h2>

            <div id="Resa" class="accordion-collapse collapse shadow" aria-labelledby="headingResa"
                data-bs-parent="#accordionExample">
                <div class="accordion-body">
                    <div class="d-flex justify-content-end mb-3">
                        <button class="btn btn-success" @click="addRule()">+ Nuovo</button>
                    </div>

                    <div class="table-responsive">
                        <table class="table table-sm table-hover table-striped align-middle">
                            <thead class="table-light">
                                <tr>
                                    <th>ID</th>
                                    <th>Il Prodotto:</th>
                                    <th>Ha Resa</th>
                                    <th>Se è attivo il Prodotto:</th>
                                    <th class="text-end">Azioni</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(rule,i) in rules" :key="rule.id">
                                    <td>{{ rule.id }}</td>
                                    <td><select v-model="rule.yield_product_id">
                                        <option v-for="product in products" :key="product.id" :value="product.id">{{product.product_name}}</option>
                                    </select></td>
                                    <td><input type="number" v-model="rule.yield_override" step=".01"></td>
                                    <td><select v-model="rule.condition_product_id">
                                        <option v-for="product in products" :key="product.id" :value="product.id">{{product.product_name}}</option>
                                    </select></td>
                                    <td class="text-end">
                                        <button class="btn btn-sm" :class="{ 'btn-success': rule.id==0,'btn-outline-success': rule.id!=0  }" @click="saveRule(i)">Salva</button>
                                        <button class="btn btn-sm btn-outline-danger" @click="deleteRule(i)">Elimina</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        </div>
    </div>



    <div class="modal modal-xl fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
        ref="modalCond">
        <div class="modal-dialog modal-xl">
            <div class="modal-content shadow-lg p-4">

                <!-- Header -->
                <div class="modal-header">
                    <h5 class="modal-title">Modifica Sistema</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Chiudi"></button>
                </div>

                <!-- Body -->
                <div class="modal-body">

                    <!-- Dati Sistema -->
                    <section class="mb-5">
                        <h4 class="mb-3">Dati Sistema</h4>
                        <form class="mx-auto mb-4" style="max-width: 500px;">
                            <div class="mb-3">
                                <label for="username" class="form-label">Nome sistema</label>
                                <input type="text" id="username" class="form-control"
                                    v-model="selectedSystem.system_name" required>
                            </div>
                        </form>

                        <form class="mx-auto" style="max-width: 500px;">
                            <p class="fw-semibold">Superfici applicabili:</p>
                            <div class="d-flex flex-column gap-2">
                                <div v-for="base in bases" :key="base.id"
                                    class="form-check form-switch d-flex justify-content-between">
                                    <label class="form-check-label me-2">{{ base.base_name }}</label>
                                    <input class="form-check-input" type="checkbox" role="switch"
                                        :checked="selectedSystem.bases && selectedSystem.bases.some(obj => obj.id === base.id)"
                                        @change="toggleBase(base)">
                                </div>
                            </div>
                            <div class="text-end mt-3">
                                <button type="button" class="btn btn-success" @click="postSystemData()">Salva</button>
                            </div>
                        </form>
                    </section>

                    <!-- Prodotti e Condizioni -->
                    <hr class="my-5" />
                    <section>
                        <h4 class="mb-4">Prodotti e Condizioni</h4>

                        <div v-if="selectedSystem.id != -1" class="d-flex gap-4">


                            <!-- 
                            <draggable :list="conditions" class="drag-area" @change="handleChange">
                                <div v-for="element in conditions" :key="element.product_order" class="drag-item">
                                    {{ element.sub_product_name }}
                                </div>
                            </draggable> -->


                            <!-- Sidebar: Prodotti -->
                            <div class="nav flex-column nav-pills me-3" id="v-pills-tab" role="tablist">
                                <p class="fw-semibold mb-2">Prodotti: (Trascina per riordinare)</p>


                                <ul class="list-group">
                                    <!-- <button class="nav-link" :class="{ active: i === 0 }" -->
                                    <draggable :list="conditions" class="drag-area" @change="handleChange">
                                        <li class="list-group-item" v-for="(subProduct, i) in conditions"
                                            :key="subProduct.sub_product_id" data-bs-toggle="pill"
                                            :data-bs-target="'#v-pills-' + subProduct.sub_product_id" type="button"
                                            role="tab" :aria-controls="'v-pills-' + subProduct.sub_product_id">{{
                                                subProduct.sub_product_name }}</li>
                                    </draggable>
                                </ul>



                                <!-- <draggable :list="conditions" class="drag-area" @change="handleChange">
                                    <button class="nav-link" v-for="(subProduct, i) in conditions"
                                        :key="subProduct.sub_product_id" data-bs-toggle="pill"
                                        :data-bs-target="'#v-pills-' + subProduct.sub_product_id" type="button"
                                        role="tab" :aria-controls="'v-pills-' + subProduct.sub_product_id">
                                        {{ subProduct.sub_product_name }}
                                    </button>
                                </draggable> -->




                                <select v-model="newSubProduct.id" class="form-select mt-3">
                                    <option value="-1">Aggiungi Nuovo</option>
                                    <option v-for="product in products" :key="product.id" :value="product.id">
                                        {{ product.product_name }}
                                    </option>
                                </select>

                                <button class="btn btn-success mt-2" @click="addSubProduct()">Aggiungi Prodotto</button>
                            </div>

                            <!-- Content: Condizioni -->
                            <div class="tab-content flex-grow-1" id="v-pills-tabContent">
                                <div v-for="subProduct in conditions" :key="subProduct.sub_product_id"
                                    class="tab-pane fade" :id="'v-pills-' + subProduct.sub_product_id" role="tabpanel">
                                    <p class="fw-semibold">Resa</p>
                                    <input type="number" v-model="subProduct.yield" step=".01"></input>
                                    <p style="color:red" v-if="rules.some((v)=>{if(v.yield_product_id==subProduct.sub_product_id && conditions.some((c)=>{if(c.sub_product_id == v.condition_product_id){return true}})){return true}})">Ci sono delle regole di override impostate per questo prodotto.</p>
                                    <button class="btn btn-success mt-2"
                                        @click="updateYield(subProduct.sub_product_id, subProduct.system_id, subProduct.yield)">Salva</button>

                                    <p class="fw-semibold">Lista condizioni</p>
                                    <ul class="list-group mb-3">
                                        <li class="list-group-item d-flex flex-wrap align-items-center gap-3"
                                            v-for="(condition, i) in subProduct.conditions"
                                            :key="condition.condition_id">

                                            <select v-if="i > 0" v-model="condition.condition_logic"
                                                class="form-select w-auto">
                                                <option value="and">E</option>
                                                <option value="or">O</option>
                                            </select>

                                            <select v-model="condition.condition_type" class="form-select w-auto">
                                                <option value="always">Sempre presente</option>
                                                <option value="mq">MQ</option>
                                                <option value="base">Base</option>
                                            </select>

                                            <!-- MQ Condition -->
                                            <div v-if="condition.condition_type === 'mq'"
                                                class="d-flex align-items-center gap-2">
                                                <select v-model="condition.mq_logic" class="form-select w-auto">
                                                    <option value="bigger_than">più di</option>
                                                    <option value="less_than">meno di</option>
                                                </select>
                                                <input v-model="condition.mq_value" type="number"
                                                    class="form-control w-auto" />
                                            </div>

                                            <!-- Base Condition -->
                                            <div v-if="condition.condition_type === 'base'" class="w-auto">
                                                <select v-model="condition.base_id" class="form-select">
                                                    <option v-for="base in bases" :key="base.id" :value="base.id">
                                                        {{ base.base_name }}
                                                    </option>
                                                </select>
                                            </div>

                                            <button class="btn btn-sm btn-outline-danger"
                                                v-if="condition.condition_id === -1 || i === subProduct.conditions.length - 1"
                                                @click="removeCondition(condition, subProduct.sub_product_id, i)">
                                                X
                                            </button>
                                        </li>
                                    </ul>

                                    <!-- Action Buttons -->
                                    <div class="d-flex gap-2">
                                        <button class="btn btn-warning"
                                            @click="addCondition(subProduct.sub_product_id, subProduct.system_id)">
                                            Aggiungi condizione
                                        </button>
                                        <button class="btn btn-success"
                                            @click="testConditions(subProduct)">Test</button>
                                        <button class="btn btn-success"
                                            @click="postConditions(subProduct)">Salva</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Message if system not saved -->
                        <p v-else class="text-muted">Salva il Sistema per inserire i prodotti</p>

                        <!-- Delete System -->
                        <div v-if="selectedSystem.id != -1" class="text-end mt-4">
                            <button class="btn btn-danger" @click="deleteSystem()">Elimina</button>
                        </div>
                    </section>

                </div>
            </div>
        </div>
    </div>




    <div class="modal modal-xl fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
        ref="modalGroup">
        <div class="modal-dialog modal-xl">
            <div class="modal-content shadow-lg p-4">
                <!-- Header -->
                <div class="modal-header">
                    <h5 class="modal-title">Modifica Gruppo</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Chiudi"></button>
                </div>

                <!-- Body -->
                <div class="modal-body">

                    <!-- Dati Sistema -->
                    <section class="mb-5">
                        <h4 class="mb-3">Dati Gruppo</h4>
                        <form class="mx-auto mb-4" style="max-width: 500px;">
                            <div class="mb-3">
                                <label for="username" class="form-label">Nome Gruppo</label>
                                <input type="text" id="username" class="form-control" v-model="selectedGroup.group_name"
                                    required>
                            </div>
                            <button type="button" class="btn btn-success" @click="postGroup()">Salva</button>
                        </form>
                    </section>

                    <!-- Prodotti e Condizioni -->
                    <hr class="my-5" />
                    <section>
                        <h4 class="mb-4">Prodotti</h4>

                        <div v-if="selectedGroup.id != -1" class="d-flex gap-4">
                            <div><select v-model="newSubProduct.id" class="form-select mt-3">
                                    <option value="-1">Aggiungi Nuovo</option>
                                    <option v-for="product in products" :key="product.id" :value="product.id">
                                        {{ product.product_name }}
                                    </option>
                                </select>

                                <button class="btn btn-success mt-2" @click="addSubProductToGroup()">Aggiungi
                                    Prodotto</button>
                            </div>


                            <!-- Content: Condizioni -->
                            <div class="tab-content flex-grow-1" id="v-pills-tabContent">
                                Lista prodotti:
                                <ul class="list-group">
                                    <li class="list-group-item" v-for="product in selectedGroup.products"
                                        :key="product.sub_product_id" role="tab">{{ product.prodName }}<span><button
                                                class="btn btn-danger" style="float:right"
                                                @click="deleteSubProductFromGroup(product)">X</button></span></li>
                                </ul>
                            </div>
                        </div>

                        <!-- Message if system not saved -->
                        <p v-else class="text-muted">Salva il Gruppo per inserire i prodotti</p>

                        <!-- Delete System -->
                        <div v-if="selectedGroup.id != -1" class="text-end mt-4">
                            <button class="btn btn-danger" @click="deleteGroup()">Elimina</button>
                        </div>
                    </section>

                </div>
            </div>
        </div>
    </div>






    <div class="modal modal-xl fade" tabindex="-1" aria-labelledby="myModalLabel" aria-hidden="true" ref="modalUser">
        <div class="modal-dialog modal-xl">
            <div class="modal-content shadow p-4">

                <!-- Header -->
                <div class="modal-header">
                    <h5 class="modal-title">Dati Utente</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Chiudi"></button>
                </div>

                <!-- Body -->
                <div class="modal-body d-flex justify-content-center">
                    <form class="w-100" style="max-width: 500px;">

                        <!-- Username -->
                        <div class="mb-3">
                            <label for="username" class="form-label">Username</label>
                            <input type="text" id="username" name="username" class="form-control"
                                v-model="selectedUser.username" required />
                        </div>

                        <!-- Email -->
                        <div class="mb-3">
                            <label for="email" class="form-label">Email</label>
                            <input type="email" id="email" name="email" class="form-control"
                                v-model="selectedUser.email" required />
                        </div>

                        <!-- Password (only if new user) -->
                        <div class="mb-3" v-if="selectedUser.id === -1">
                            <label for="password" class="form-label">Password</label>
                            <input type="password" id="password" name="password" class="form-control"
                                v-model="selectedUser.password" required />
                        </div>

                        <!-- Role -->
                        <div class="mb-4">
                            <label for="role" class="form-label">Ruolo</label>
                            <select id="role" class="form-select" v-model="selectedUser.role">
                                <option value="1">Agente</option>
                                <option value="2">Admin</option>
                            </select>
                        </div>

                        <!-- Price listing -->
                        <div class="mb-3">
                            <label for="listing" class="form-label">ID Listino</label>
                            <!-- <input type="number" id="listing" name="listing" class="form-control"
                                v-model="selectedUser.price_list_id" required /> -->
                            <select v-model="selectedUser.price_list_id" class="form-select">
                                <option value="3">3</option>
                                <option value="5">5</option>
                                <option value="7">7</option>
                            </select>
                        </div>

                        <!-- Action Buttons -->
                        <div class="d-flex gap-2">
                            <button type="button" class="btn btn-success w-100" @click="postUser()">Salva</button>
                            <button v-if="selectedUser.id !== -1" type="button" class="btn btn-danger w-100"
                                @click="deleteUser()">
                                Elimina
                            </button>
                        </div>
                    </form>
                </div>

            </div>
        </div>
    </div>

    <div class="modal modal-xl fade" tabindex="-1" aria-labelledby="myModalLabel" aria-hidden="true" ref="modalBase">
        <div class="modal-dialog modal-xl">
            <div class="modal-content shadow p-4">

                <!-- Header -->
                <div class="modal-header">
                    <h5 class="modal-title">Nome Superficie</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Chiudi"></button>
                </div>

                <!-- Body -->
                <div class="modal-body d-flex justify-content-center">

                    <form class="w-100" style="max-width: 500px;">
                        <!-- Base Name -->
                        <div class="mb-3">
                            <label for="base_name" class="form-label">Nome Superficie</label>
                            <input type="text" id="base_name" name="base_name" class="form-control"
                                v-model="newBase.base_name" required />
                        </div>
                        <div class="d-flex gap-2">
                            <button type="button" class="btn btn-success w-100" @click="postBase()">Salva</button>
                            <button v-if="newBase.id !== -1" type="button" class="btn btn-danger w-100"
                                @click="deleteBase()">
                                Elimina
                            </button>
                        </div>
                    </form>
                </div>

            </div>
        </div>
    </div>



</template>
<script>
import { onMounted, ref } from 'vue'
import userMethods from '../api/resources/usersMethods'
import systemMethods from '../api/resources/systemMethods'
import productMethods from '../api/resources/productMethods'
import { VueDraggableNext } from 'vue-draggable-next'
import { Modal } from 'bootstrap'
import { useLoading } from 'vue-loading-overlay'
export default {
    name: "AdminView",
    emits: ['alert'],
    components: {
        draggable: VueDraggableNext
    },
    setup(_, { emit }) {
        const users = ref([]);
        var modUser = ref(Modal);
        const modalUser = ref(null);
        var modCond = ref(Modal);
        const modalCond = ref(null);
        var modBase = ref(Modal);
        const modalBase = ref(null);

        var modGroup = ref(Modal);
        const modalGroup = ref(null);

        const systems = ref([]);
        const conditions = ref([]);
        const products = ref([]);
        const bases = ref([]);
        const groups = ref([]);
        const rules = ref([]);

        var loader = useLoading();
        const newSubProduct = ref({
            id: -1,
            system_id: null
        });

        const newBase = ref({
            id: -1,
            base_name: ""
        });

        const selectedUser = ref({ id: -1, username: "", email: "", role: 0 });
        const selectedGroup = ref({ id: -1, group_name: "", products: [] });

        const selectedSystem = ref({});

        const roles = ref([{ id: 1, name: "Agente" }, { id: 2, name: "Admin" }]);

        const searchUser = ref("");
        const searchSys = ref("");
        const searchSup = ref("");

        onMounted(async () => {
            modUser.value = new Modal(modalUser.value)
            modCond.value = new Modal(modalCond.value)
            modBase.value = new Modal(modalBase.value)
            modGroup.value = new Modal(modalGroup.value)
            let data = await userMethods.getUsers();
            users.value = data.data
            let dataS = await systemMethods.getSystems();
            let dataP = await productMethods.getProducts();
            let dataB = await productMethods.getBases();
            let dataG = await productMethods.getGroups();
            let dataR = await systemMethods.yieldOverrideRules()
            rules.value = dataR.data;
            systems.value = dataS.data;
            products.value = dataP.data;
            bases.value = dataB.data;
            groups.value = dataG.data;
        })
        async function loadConditions(systemId) {
            //let subProducts = [];
            conditions.value = [];
            let data = await systemMethods.getConditions(systemId);

            data.data.forEach((condition) => {
                let toAdd = true;
                let obj = {
                    sub_product_id: condition.sub_product_id,
                    sub_product_name: condition.sub_product_name,
                    product_order: condition.product_order,
                    system_id: condition.system_id,
                    yield: condition.yield,
                    conditions: []
                };
                conditions.value.forEach((e) => {
                    if (e.sub_product_id == condition.sub_product_id) {
                        toAdd = false;
                    }
                })
                if (toAdd) {
                    conditions.value.push(obj);
                }
            })

            data.data.forEach((condition) => {
                conditions.value.forEach((e) => {
                    if (e.sub_product_id == condition.sub_product_id) {
                        e.conditions.push(condition);
                    }
                })
            })
            console.log(conditions.value)
        }
        function selectUser(user) {
            selectedUser.value = user
        }
        async function postUser() {
            let lod = loader.show()
            if (selectedUser.value.id == -1) {
                await userMethods.saveUser(selectedUser.value);
            }
            else {
                await userMethods.updateUser(selectedUser.value);
            }
            let data = await userMethods.getUsers();
            users.value = data.data
            modUser.value.hide();
            lod.hide()
            emit('alert', { message: "Utenti Aggiornati!", color: "green" });
        }
        function addUser() {
            let obj = {
                id: -1,
                name: "",
                email: "",
                price_list_id: 3
            }
            selectedUser.value = obj
        }
        function addSystem() {
            let obj = {
                id: -1,
                system_name: "",
                bases: []
            }
            selectSystem(obj);
        }
        function addGroup() {
            let obj = {
                id: -1,
                group_name: "",
                products: []
            }
            selectGroup(obj);
        }
        async function deleteUser() {
            let lod = loader.show()
            await userMethods.deleteUser(selectedUser.value)
            let data = await userMethods.getUsers();
            users.value = data.data
            modUser.value.hide()
            lod.hide()
            emit('alert', { message: "Utente Eliminato!", color: "green" });
        }

        async function selectSystem(system) {
            selectedSystem.value = system
            modCond.value.show();
            await loadConditions(system.id);
        }

        async function selectGroup(group) {
            selectedGroup.value = group
            modGroup.value.show();
            //await loadProductsByGroup(group.id);
        }

        function addCondition(prodId, systemId) {
            let obj = {
                condition_id: -1,
                sub_product_id: prodId,
                system_id: systemId
            }
            conditions.value.forEach((e) => {
                if (e.sub_product_id == prodId) {
                    e.conditions.push(obj);
                }
            })
        }

        async function addSubProduct() {
            let lod = loader.show({ zIndex: 9999 })
            let obj = {
                "condition_id": -1,
                "system_id": null,
                "sub_product_id": null,
                "condition_type": "always",
                "condition_logic": 0,
                "condition _order": 1,
                "base_id": null,
                "base_reversed": null,
                "mq_logic": null,
                "mq_value": null
            }
            if (newSubProduct.value.id == -1) {
                emit('alert', { message: "Seleziona un Prodotto!", color: "red" });
                return;
            }
            obj.system_id = selectedSystem.value.id
            obj.sub_product_id = newSubProduct.value.id
            await systemMethods.postConditions({ conditions: [obj] })
            await loadConditions(selectedSystem.value.id);
            lod.hide()
            emit('alert', { message: "Prodotto aggiunto!", color: "green" });
        }

        async function removeCondition(condition, prodId, condIndex) {
            let lod = loader.show({ zIndex: 9999 })
            if (condition.condition_id != -1) {
                let res = await systemMethods.removeConditions([condition]);
                console.log(res)
            }
            else {
                console.log("è una condizione NON nel db");
            }
            conditions.value.forEach((e) => {
                if (e.sub_product_id == prodId) {
                    e.conditions.splice(condIndex, 1);
                }
            })
            await loadConditions(selectedSystem.value.id);
            lod.hide()
            emit('alert', { message: "Condizione rimossa!", color: "green" });
        }

        const toggleBase = (base) => {
            const index = selectedSystem.value.bases.findIndex(item => item.id === base.id)
            if (index > -1) {
                selectedSystem.value.bases.splice(index, 1)
            } else {
                selectedSystem.value.bases.push(base)
            }
            console.log(selectedSystem.value.bases)
        }

        async function postConditions(data) {
            let lod = loader.show({ zIndex: 9999 })
            let res = await systemMethods.postConditions(data);
            console.log(res);
            lod.hide()
            emit('alert', { message: "Condizioni aggiornate!", color: "green" });
        }

        async function postSystemData() {
            let lod = loader.show({ zIndex: 9999 })
            if (selectedSystem.value.id == -1) {
                await systemMethods.postSystem(selectedSystem.value)
                modCond.value.hide();
            }
            else {
                await systemMethods.postSystem(selectedSystem.value)
            }
            let dataS = await systemMethods.getSystems();
            systems.value = dataS.data;
            lod.hide()
            emit('alert', { message: "Sistema aggiornato!", color: "green" });
        }

        async function deleteSystem() {
            let lod = loader.show({ zIndex: 9999 })
            if (selectedSystem.value.id == -1) {
                return;
            }
            else {
                await systemMethods.deleteSystem(selectedSystem.value);
            }
            let dataS = await systemMethods.getSystems();
            systems.value = dataS.data;
            lod.hide()
            modCond.value.hide();
            emit('alert', { message: "Sistema eliminato!", color: "green" });
        }

        async function postBase() {
            let lod = loader.show()
            await productMethods.postBases(newBase.value);
            let dataB = await productMethods.getBases();
            bases.value = dataB.data;
            modBase.value.hide()
            lod.hide()
            emit('alert', { message: "Superfici aggiornate!", color: "green" });
        }

        async function deleteBase() {
            let lod = loader.show()
            await productMethods.deleteBases(newBase.value);
            let dataB = await productMethods.getBases();
            bases.value = dataB.data;
            modBase.value.hide()
            lod.hide()
            emit('alert', { message: "Superficie eliminata!", color: "green" });
        }

        async function updateYield(prodId, systemId, yieldValue) {
            let lod = loader.show()
            let obj = {
                prodId: prodId,
                systemId: systemId,
                yield: yieldValue
            }
            await productMethods.updateYield(obj)
            lod.hide()
            emit('alert', { message: "Resa aggiornata!", color: "green" });
        }
        async function handleChange(event) {
            let lod = loader.show()
            event.moved.element.product_order = event.moved.newIndex

            for (const [index, subProd] of conditions.value.entries()) {
                subProd.product_order = index;
            }
            await productMethods.updateProductOrder(conditions.value);
            lod.hide()
        }
        async function postGroup() {
            let lod = loader.show()
            let obj = selectedGroup.value;
            await productMethods.postGroup(obj);
            let dataG = await productMethods.getGroups();
            groups.value = dataG.data;
            modGroup.value.hide()
            lod.hide()
            emit('alert', { message: "Gruppi aggiornati!", color: "green" });
        }
        async function deleteGroup() {
            let lod = loader.show()
            let obj = selectedGroup.value;
            if (obj.id != -1) {
                await productMethods.deleteGroup(obj);
                let dataG = await productMethods.getGroups();
                groups.value = dataG.data;
            }
            else {
                let group = {
                    id: -1,
                    group_name: "",
                    products: []
                }
                selectedGroup.value = group;
            }
            modGroup.value.hide()
            lod.hide()
            emit('alert', { message: "Gruppi aggiornati!", color: "green" });
        }
        async function addSubProductToGroup() {
            let lod = loader.show()
            let obj = {
                groupId: selectedGroup.value.id,
                productId: newSubProduct.value.id
            };
            await productMethods.addSubProductToGroup(obj);
            let dataG = await productMethods.getGroups();
            groups.value = dataG.data;
            modGroup.value.hide()
            lod.hide()
            emit('alert', { message: "Gruppo aggiornato!", color: "green" });
        }
        async function deleteSubProductFromGroup(subProd) {
            let lod = loader.show()
            let obj = {
                prodId: subProd.prodId,
                groupId: selectedGroup.value.id
            }
            await productMethods.deleteSubProductFromGroup(obj);
            let dataG = await productMethods.getGroups();
            groups.value = dataG.data;
            modGroup.value.hide()
            lod.hide()
            emit('alert', { message: "Gruppo aggiornato!", color: "green" });
        }

        function addRule(){
            let obj = {
                id:0,
                yield_product_id:1,
                condition_product_id:1,
                yield_override:1
            }
            rules.value.push(obj);
        }

        async function saveRule(i){
            console.log(rules.value[i])
            await systemMethods.postYieldRule(rules.value[i]);
            let dataR = await systemMethods.yieldOverrideRules()
            rules.value = dataR.data;
        }
        async function deleteRule(i){
            if(rules.value[i].id == null){
                rules.value.splice(i,1);
            }
            else{
                await systemMethods.deleteYieldRule(rules.value[i]);
                let dataR = await systemMethods.yieldOverrideRules()
                rules.value = dataR.data;
            }
        }

        return {
            modUser, modalUser, modCond, modalCond,
            users, roles,
            selectUser, selectedUser, selectedSystem, postUser, addUser, deleteUser, loadConditions,
            systems, selectSystem, bases, conditions, products,
            addCondition, removeCondition, newSubProduct, addSubProduct,
            toggleBase, postConditions, addSystem, postSystemData, deleteSystem,
            newBase, modBase, modalBase, postBase, deleteBase, updateYield,
            handleChange, groups, modalGroup, modGroup, selectedGroup, addGroup, selectGroup, postGroup, deleteGroup, addSubProductToGroup, deleteSubProductFromGroup,
            rules,addRule,saveRule,deleteRule,
            searchUser,searchSup,searchSys
        }
    }
}
</script>